module.exports = __webpack_public_path__ + "static/img/industries10.f2f3b17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industries10.png
// module id = VeZi
// module chunks = 1